import React from 'react'
import CSSModules from 'react-css-modules'

import theme from './Divider.scss'

const Divider = (props) => {
  return <hr class={`${theme.divider} ${props.className}`}/>
}

export default CSSModules(Divider, theme)
